module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.1@core-js/library/modules/_library.js
// module id = 18
// module chunks = 0